var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Inject, State, Mutation } from 'vue-class-state';
import { createLock, checkLogin } from '../../common/decorators';
import { jsonp, post } from '../../common/http';
import querystring from 'querystring';
export class SubscribeState {
    constructor() {
        this.subList = [];
        this.pagenum = 1;
        this.pagesize = 5;
        this.total = null;
        this.isHasSub = false;
        this.hasNextPage = true;
        this.pageContext = {};
    }
    get hasData() {
        return this.subList.length;
    }
    loadSubList() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasNextPage) {
                return;
            }
            try {
                const res = yield jsonp('https://nodeyun.video.qq.com/x/api/usercenter/subscribe', { page_context: this.pageContext });
                if (res.ret == 0 && res.data && res.data.funcRet === 0) {
                    if (Array.isArray(res.data.body.modules)) {
                        this.setSubList(res.data.body.modules);
                    }
                    if (res.data.body.modules.length) {
                        this.pageContext = querystring.stringify(res.data.body.page_context);
                    }
                    else {
                        this.pageContext = {};
                        this.hasNextPage = false;
                        return;
                    }
                }
            }
            catch (error) {
                console.error(error);
            }
            finally {
                Mutation.commit(this, () => this.isHasSub = true);
            }
        });
    }
    setSubList(data) {
        data.forEach((mod) => {
            const list = mod.sections;
            if (!list.length) {
                return;
            }
            const accountData = list[0].block_list.blocks[0].data.account_info;
            const subItem = list[0].block_list.blocks[0].data;
            if (!subItem) {
                return;
            }
            subItem.avatar = list[0].block_list.blocks[0].data.user_image_url;
            subItem.uin = accountData.account_id;
            subItem.nick = list[0].block_list.blocks[0].data.user_name;
            if (list[1].block_list != null) {
                subItem.vs = list[1].block_list.blocks.map((item) => {
                    const video = item.data;
                    const extra = item.extra_data;
                    const prime = item.mark_label_list_map[0].mark_label_list[0].prime_text;
                    video.vid = extra.data[1].item_id;
                    video.video_uploadTime = extra.data[4].text;
                    video.pic = video.image_url;
                    video.duration = prime;
                    return video;
                });
            }
            else {
                subItem.vs = [];
            }
            subItem.isSub = true;
            this.subList.push(subItem);
        });
    }
    sub(uin, isAdd) {
        return __awaiter(this, void 0, void 0, function* () {
            const accessDomain = location && location.host === 'v.qq.com' ? 'access.video.qq.com' : 'debugaccess.video.qq.com';
            const api = `https://${accessDomain}/user/ugc_userinfo_follow?vappid=21403953&vsecret=58648bf6abcd2e6fe51f83ef47059ecdb3fd4d09c72b9d9c&vplatform=2&raw=1`;
            const myVuid = txv.cookie && (txv.cookie.get('vqq_vuserid') || txv.cookie.get('vuserid'));
            const params = {
                type: isAdd ? 1 : 2,
                toUserId: String(uin),
                fromUserId: myVuid,
            };
            yield post(api, params);
            this.updateSubItem(uin, { isSub: isAdd });
        });
    }
    subCreator(vcuid, isAdd) {
        return __awaiter(this, void 0, void 0, function* () {
            const accessDomain = location && location.host === 'v.qq.com' ? 'pbaccess.video.qq.com' : 'tpbaccess.video.qq.com';
            const api = `https://${accessDomain}/trpc.video_app_short_video.trpc_user_subscribe_service.UserSubscribeData/CreatorSubscribe`;
            const params = {
                operation_type: isAdd ? 1 : 2,
                vcuid,
            };
            yield post(api, params, true);
            this.updateSubItem(vcuid, { isSub: isAdd });
        });
    }
    updateSubItem(uin, data) {
        const target = this.subList.find(item => String(item.uin) === String(uin));
        if (target) {
            Object.assign(target, data);
        }
    }
}
__decorate([
    State
], SubscribeState.prototype, "subList", void 0);
__decorate([
    State
], SubscribeState.prototype, "total", void 0);
__decorate([
    State
], SubscribeState.prototype, "isHasSub", void 0);
__decorate([
    createLock(),
    checkLogin
], SubscribeState.prototype, "loadSubList", null);
__decorate([
    Mutation
], SubscribeState.prototype, "setSubList", null);
__decorate([
    checkLogin
], SubscribeState.prototype, "sub", null);
__decorate([
    checkLogin
], SubscribeState.prototype, "subCreator", null);
__decorate([
    Mutation
], SubscribeState.prototype, "updateSubItem", null);
export const ISubscribeState = Inject('subscribe');
/**
 (1) 命令字对应jce文件，以及请求和相应结构体
(2) 命令字对应L5
(3) 命令字对应cgi名称等

2. 关注
命令字: 0xc9
L5: 499521:327680
cgi: vpp_add_follow
请求： FollowReq
响应： SetRsp
http://debugaccess.video.qq.com/user/vpp_add_follow?vappid=19074190&vsecret=dec3963b29ccc1c4ab9b9af1d2fbddd437e853a9f24c18cc&vversion_name=5.4.0.1236&vplatform=3

{
    "user": {
        "userType": 0,
        "userId": "344261163"
    },
    "vppId": {
        "vppType": 0,
        "vppId": 2164960269
    }
}

2. 取消关注
命令字: 0xca
L5: 499521:327680
cgi: vpp_del_follow

http://debugaccess.video.qq.com/user/vpp_del_follow?vappid=19074190&vsecret=dec3963b29ccc1c4ab9b9af1d2fbddd437e853a9f24c18cc&vversion_name=5.4.0.1236&vplatform=3

{
    "user": {
        "userType": 0,
        "userId": "344261163"
    },
    "vppId": {
        "vppType": 0,
        "vppId": 2164960269
    }
}

3. 关注列表
命令字：0xf8e1
L5 : 499521:393216    301249:8847360
cgi:  vpp_follow_list
请求： VisitUser
响应： QueryFollowVppsRsp

http://debugaccess.video.qq.com/user/vpp_follow_list?vappid=19074190&vsecret=dec3963b29ccc1c4ab9b9af1d2fbddd437e853a9f24c18cc&vversion_name=5.4.0.1236&vplatform=3

{"strUsrId": "344261163", "pageContext":""}

1. 关注
命令字: 0xc9
L5: 499521:327680（测试） 410625:1507328（正式）
请求： FollowReq
响应： SetRsp

2. 取消关注
命令字: 0xca
L5: 499521:327680（测试） 410625:1507328（正式）
请求： FollowReq
响应： SetRsp

3. 关注列表
命令字：0xf8e1
L5 : 499521:393216（测试） 410625:1441792（正式）
请求： VisitUser
响应： QueryFollowVppsRsp

4. 粉丝数
命令字：0xf903
L5: 499521:393216（测试） 410625:1441792（正式）
请求：stQueryVppFansCountReq
相应：stQueryVppFansCountRsp
 */
